<template>
    <div class='order-form-template'>
        <div class="order-form-template-title">
            {{ headerTitle }}
        </div>
        <div class="order-form-template-content" :class="{'show-border': showBorder}">
            <slot/>
        </div>
    </div>
</template>

<script lang='ts'>
export default {
    props: {
        showBorder: {
            type: Boolean,
            default: true
        },
        headerTitle: {
            type: String,
            default: '头部信息'
        }
    }
}
</script>

<style lang="scss" scoped>
.order-form-template {
    position: relative;
    margin-top: 20px;
    font-size: 14px;
    color: #333;

    &-title {
        display: flex;
        align-items: center;
        font-weight: bolder;

        &::before {
            content: '';
            display: inline-block;
            width: 4px;
            height: 20px;
            margin-right: 4px;
            background: #009688;
            border-radius: 2px;
        }
    }

    &-content {
        margin-top: 12px;

        &.show-border {
            border: 1px solid #ebebeb;
        }
    }
}
</style>
